module.exports = __webpack_public_path__ + "static/media/contasis_logo_mobile.bef6c919.webp";